import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as _ from 'lodash';
import {switchMap, take} from 'rxjs/internal/operators';
import {catchError, map} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {culturesActionTypes, LoadCulturesFailAction, LoadCulturesSuccessAction} from '../actions/cultures';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {Culture} from '../models/culture';
import {SendBackResult} from '../models/send-back-result';
import {CulturesService} from '../services/cultures.service';
import {BaseEffect} from './base.effect';
import {L10nTranslationService} from 'angular-l10n';
import {of} from 'rxjs';
import {ApiCacheService} from '../services/cache.service';

@Injectable()
export class CulturesEffect extends BaseEffect {

  load$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(culturesActionTypes.LOAD),
      debug('Load cultures action received;'),
      switchMap(() => {
        const cacheKey = 'cultures';
        const cached = this.apiCacheService.get<Culture[]>(cacheKey);

        if (cached) {
          return of(new LoadCulturesSuccessAction(_.orderBy(cached, ['code'])));
        }

        return this.culturesService.getList().pipe(
          map((payload: SendBackResult<ArrayResponse<Culture>>) => {
            const cultures = _.orderBy(payload.data.array, ['code']);
            this.apiCacheService.set(cacheKey, cultures);
            return new LoadCulturesSuccessAction(cultures);
          }),
          catchError(res => this.catchResponseError(res))
        );
      }),
      take(1)
    );
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(ofType(culturesActionTypes.LOAD_FAIL),
    debug('Load cultures fail action received.'),
    map((err: LoadCulturesFailAction ) =>
      error(this.translation.translate('CULTURES_LOAD_ERROR') + err.payload, this.translation.translate('TOAST_ERROR_TITLE'))
    ))
  });

  constructor(private actions$: Actions,
              private apiCacheService: ApiCacheService,
              private translation: L10nTranslationService ,
              private culturesService: CulturesService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadCulturesFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadCulturesFailAction(response['error'].message);
  }
}
